import React, { useState, useEffect } from 'react'
import useTranslation from 'next-translate/useTranslation'
import {
  InfoWrapper,
  DesktopHeroWrapper,
  Spacer,
  Description,
  HeroHeader,
} from '../../../Essentials/components/Hero/Hero.styles'
import {
  MobileWrapper,
} from 'features/components/ProductDetailHero/ProductDetailHero.styles'
import { Stack } from 'components/Stack'
import { HeroImage } from 'features/components/ProductDetailHero/components/HeroImage'
import { InformationCollapse, InformationCollapseType } from 'components/InformationCollapse'
import { ProductDetailHero } from 'features/components/ProductDetailHero'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'
import { HeroTitle } from 'features/components/ProductDetailHero/components/HeroHeader/HeroHeader.styles'
import thumbnail from '../../../../../../../../public/assets/product/startr-short.webp'
import { HeroRoot, ContentContainer } from './Hero.styles'

type HeroProps = {}

export const Hero = ({}: HeroProps) => {
  const { t } = useTranslation()

  const infoList: InformationCollapseType[] = [
    {
      label: 'products:startr.hero.ingredients.label',
      description: 'products:startr.hero.ingredients.description',
    },
    {
      label: 'products:startr.hero.nutrition.label',
      description: 'products:startr.hero.nutrition.description',
    },
    {
      label: 'products:startr.hero.directions.label',
      description: 'products:startr.hero.directions.description',
    },
    {
      label: 'products:startr.hero.firstTime.label',
      description: 'products:startr.hero.firstTime.description',
    },
  ]

  return (
    <HeroRoot>
      <ProductDetailHero>
        <DesktopHeroWrapper>
          <HeroImage thumbnail={thumbnail} alt={t('products:startr.hero.thumbnailAlt')} />
        </DesktopHeroWrapper>
        <ContentContainer>
          <MobileWrapper></MobileWrapper>
          <Stack direction="column" alignItems="center" gap={{ '@initial': '2', '@bp3': '5' }}>
            <HeroHeader>
              <HeroTitle>{t('products:startr.hero.title')}</HeroTitle>
              <Description
                align="center"
                size={{'@initial': 'body', '@bp3': 'bodyLarge'}}
                color="accent-black"
                css={{maxWidth: '300px' , '@bp3': {maxWidth: '450px'}}}
              >
                <Trans i18nKey={'products:startr.hero.subtitle'} components={{ br: <br />, span: <span /> }} />
              </Description>
            </HeroHeader>
            <MobileWrapper>
              <HeroImage thumbnail={thumbnail} alt={t('products:essentials.hero.thumbnailAlt')} />
            </MobileWrapper>

            <Stack direction="column" alignItems="center" width="fullWidth">
              <Button>
                {t('products:startr.cta')}
              </Button>
            </Stack>
          </Stack>
          <Spacer />
          <InfoWrapper>
            <InformationCollapse infoList={infoList} />
          </InfoWrapper>
        </ContentContainer>
      </ProductDetailHero>
    </HeroRoot>
  )
}

Hero.displayName = 'Hero'
